// In Components/Login/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { FaEnvelope, FaLock } from 'react-icons/fa';
import { login } from '../Api/Api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await login(email, password);
      const adminDetail = response?.data?.response?.detail || null;
      const responseData = adminDetail || response?.data?.response?.data || response?.data;
      const userName = responseData?.full_name || responseData?.name || 'User';
      const adminUser = { ...(responseData || {}), email: responseData?.email || email };
      const token = response?.data?.response?.token || response?.data?.token;
      if (!token) throw new Error('No token received from login API');

      localStorage.setItem('token', token);
      localStorage.setItem('userName', userName);
      localStorage.setItem('admin_user', JSON.stringify(adminUser));
      navigate('/home', { state: { userName }, replace: true });
    } catch (err) {
      setError(err?.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell single">
      <form className="auth-card" onSubmit={handleLogin}>
        {/* 🔹 Only brand title */}
        <h2 className="brand-title">KonnectFBR</h2>

        {error && <div className="alert danger">{error}</div>}

        <div className="field">
          <label htmlFor="email">Email</label>
          <div className="input with-icon">
            <FaEnvelope className="icon" />
            <input
              id="email"
              type="email"
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
        </div>

        <div className="field">
          <label htmlFor="password">Password</label>
          <div className="input with-icon">
            <FaLock className="icon" />
            <input
              id="password"
              type={showPw ? 'text' : 'password'}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
            />
            <button
              type="button"
              className="ghost-eye"
              onClick={() => setShowPw((v) => !v)}
              aria-label="Toggle password visibility"
            >
              {showPw ? '🙈' : '👁️'}
            </button>
          </div>
        </div>

        <button type="submit" className="btn primary wide" disabled={loading}>
          {loading ? 'Signing in…' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default Login;
